<template>
  <layoutUpDown>
    <el-form class="el-row" label-width="130px" slot="middle">
      <el-col :span="11">
        <el-form-item label="表单名称">
          <el-input v-model="rightModel.formName" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="表单代码">
          <el-input v-model="rightModel.formCode" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="表单类别">
          <el-input v-model="rightModel.formParentName" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item label="关联费用类型">
          <SelectMultiTreeFull
            :disabled="!isEdit"
            :valueList="rightModel.formExpenseTypes"
            :treeUrl="'/em/expenseType/transition/tree?disabled=false'"
            title="选择费用类型"
            placeholder="若不配置则该表单中所有启用状态的费用类型都可选择"
            @NewList="ExpenseTypesNewList"
            @DelOne="ExpenseTypesDelOne"
          ></SelectMultiTreeFull>
        </el-form-item>
      </el-col>
    </el-form>

    <div slot="down" style="text-align:center;padding:5px 5px 5px 0;">
      <div v-if="isEdit" :key="1">
        <el-button @click="CancelEdit()">取消</el-button>
        <el-button @click="DoSave()" type="primary">保存</el-button>
      </div>
      <div v-else :key="2">
        <el-button @click="isEdit=true">编辑</el-button>
      </div>
    </div>
  </layoutUpDown>
</template>

<script>
import apiAxios from '@/apiAxios.js'
import { cloneDeep } from '@/common/util/cloneDeep.js'
export default {
  props: {
    rightModel: null,
  },
  computed: {},
  data() {
    return {
      isEdit: false,
    }
  },
  methods: {
    ExpenseTypesNewList(list1) {
      this.rightModel.formExpenseTypes = list1.map(vv1 => ({
        id: vv1.id,
        name: vv1.name,
      }))
    },
    ExpenseTypesDelOne(node, index) {
      this.rightModel.formExpenseTypes.splice(index, 1)
    },
    getPostModel() {
      const postModel = cloneDeep(this.rightModel)
      postModel.formExpenseTypes = postModel.formExpenseTypes.map(vv1 => ({
        expenseTypeId: vv1.id,
      }))
      return postModel
    },
    CancelEdit() {
      this.$emit('ReloadItem')
      this.isEdit = false
    },
    async DoSave() {
      const postModel = this.getPostModel()
      const { data } = await apiAxios.post(`/em/formDetail`, postModel)
      this.$message.success(data.message)
      this.isEdit = false
    },
  },
}
</script>
